import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideDefaultConfig } from '@spartacus/core';
import { defaultOnNavigateConfig } from "@spartacus/storefront";
import { GenOnNavigateService } from "../services/on-navigate.service";

@NgModule({
  imports: [
    RouterModule.forRoot([], {
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  providers: [
    provideDefaultConfig(defaultOnNavigateConfig),
    provideAppInitializer(() => {
        const initializerFn = (onNavigateFactory)(inject(GenOnNavigateService));
        return initializerFn();
      }),
  ],
})
export class GenAppRoutingModule {}

export function onNavigateFactory(
  onNavigateService: GenOnNavigateService
): () => void {
  const isReady = () => onNavigateService.initializeWithConfig();
  return isReady;
}
